// extracted by mini-css-extract-plugin
export default {"customCheckbox":"CustomCheckbox_customCheckbox__PmpnP","checkmark":"CustomCheckbox_checkmark__W1QLm"};